import { useState, useRef } from "react";
import { connect } from "react-redux";
import { Button, Table } from "antd";
import Column from "antd/es/table/Column";
import { DownOutlined, PlusOutlined, RightOutlined } from "@ant-design/icons";
import moment from "moment";
import { clearShiftDetails, cloneRole, deleteRole, deleteShift, getEventShiftDetails, updateRoleToTemplateForEdit, addPersonToRole, updatePersonToRole, deletePersonFromRole } from "../../../../store/actions/shifts";
import { success as toastSuccess, error as toastError } from "../../../toast";
import DeleteRole from "./DeleteRoleModal";
import DeleteShift from "./DeleteShiftModal";
import AddRole from "./AddRole";
import "./shifts.css";
import ShiftPopup from "./ShiftPopup";
import AddTalent from "./AddTalent";
import { roleStatsColor } from "../../../../constants/shifts";
import Skills from "./role/Skills";
import Composition from "./role/Composition";
import RoleActionsMenu from "./role/RoleActionsMenu";
import Staff from "./role/Staff";
import EventRoleTag from "./role/EventRoleTag";
import SubLocation from "./role/SubLocation";
import Notes from "./role/Notes";
import Attire from "./role/Attire";
import Rate from "./role/Rate";
import MinRating from "./role/MinRating";
import AddGenerateRoleActions from "./AddGenerateRoleActions";
import RoleExpandableRow from "./RoleExpandableRow";
import ShiftHeader from "./ShiftHeader";

const ShiftList = (props) => {
  const {
    eventUUID,
    shiftList,
    triggerCloneRole,
    triggerDeleteRole,
    triggerDeleteShift,
    triggerGetEventShifts,
    triggerClearShiftDetails,
    triggerUpdateRoleToTemplateForEdit,
    getUpdatedShiftList,
    triggerAddPersonToRole,
    triggerUpdatePersonToRole,
    triggerDeletePersonFromRole,
    setSelectedSection
  } = props;
  const [moreOptionRoleUUID, setMoreOptionRoleUUID] = useState(null);
  const [loadingShift, setLoadingShift] = useState(null);
  const [showDeleteRoleModal, setShowDeleteRoleModal] = useState(false);
  const [showDeleteShiftModal, setShowDeleteShiftModal] = useState(false);
  const [showAddRole, setShowAddRole] = useState(false);
  const [shiftUUIDForRole, setShiftUUIDForRole] = useState(null);
  const [roleUUIDForEdit, setRoleUUIDForEdit] = useState(null);
  const [showShiftPopup, setShowShiftPopup] = useState(false);
  const [isEditShift, setIsEditShift] = useState(false);
  const [currentShiftId, setCurrentShiftId] = useState(null);
  const [roleShiftToDelete, setRoleShiftToDelete] = useState({
    roleUUID: "",
    shiftUUID: ""
  });
  const [shiftToDelete, setShiftToDelete] = useState(null);
  const [isRoleEdit, setIsRoleEdit] = useState(false);
  const [isViewRole, setIsViewRole] = useState(false);
  const [showTalentAddPopup, setShowTalentAddPopup] = useState(false);
  const [selectedRoleUUID, setSelectedRoleUUID] = useState(null);
  const [selectedTalentForRole, setSelectedTalentForRole] = useState([]);

  const tableRef = useRef(null);
  const baseUrl = process.env.REACT_APP_API_URL;

  const toggleMoreOptions = (roleUUID) => {
    if(roleUUID) setMoreOptionRoleUUID(roleUUID);
    else setMoreOptionRoleUUID(null);
  };

  const getShiftDate = (startAt, startTZ, endAt, endTZ) => {
    if (!startAt || !endAt) {
      return ""
    }
    startAt = startAt.split("T");
    endAt = endAt.split("T");
    let startDate = moment(startAt[0]).format("MM/DD/YYYY");
    let endDate = moment(endAt[0]).format("MM/DD/YYYY");
    let startTime = startAt[1];
    let endTime = endAt[1];
    if (startDate === endDate) {
      endDate = "";
    }
    if (startTZ === endTZ) {
      startTZ = "";
    }
    const formattedStartDate = moment(startDate).format("MM/DD/YY");
    const formattedStartTime = moment(startTime, "HH:mm:ss").format("hh:mm A");
    const formattedEndDate = endDate ? moment(endDate).format("MM/DD/YY") + ", " : "";
    const formattedEndTime = moment(endTime, "HH:mm:ss").format("hh:mm A");

    const dateToReturn = `${formattedStartDate + ", "}${formattedStartTime}${
      startTZ ? " " + startTZ : ""
    } - ${formattedEndDate}${formattedEndTime} ${endTZ ? endTZ : ""}`;
    return dateToReturn;
  };

  const duplicateRole = (roleUUID, shiftUUID) => {
    setLoadingShift(shiftUUID);
    const payload = {
      actualPayload : {
        roleUUID,
        eventUUID
      },
      onSuccess: () => {
        setLoadingShift(null);
      },
      onError: (error) => {
        setLoadingShift(null);
        console.log(error);
      }
    }
    triggerCloneRole(payload);
  }

  const deleteRoleFromShift = () => {
    const { roleUUID, shiftUUID } = roleShiftToDelete;
    setLoadingShift(shiftUUID);
    const payload = {
      actualPayload : {
        roleUUID,
        eventUUID
      },
      onSuccess: () => {
        setLoadingShift(null);
        setShowDeleteRoleModal(false);
        setRoleShiftToDelete({ roleUUID: "", shiftUUID: "" });
        toastSuccess("Role removed from shift");
      },
      onError: (error) => {
        setLoadingShift(null);
        setShowDeleteRoleModal(false);
        setRoleShiftToDelete({ roleUUID: "", shiftUUID: "" });
        console.log(error);
      }
    }
    triggerDeleteRole(payload);
  }

  const deleteShiftFromEvent = () => {
    setLoadingShift(shiftToDelete);
    const payload = {
      shiftUUID: shiftToDelete,
      onSuccess: () => {
        setLoadingShift(null);
        setShowDeleteShiftModal(false);
        setShiftToDelete(null);
        toastSuccess("Shift removed from event.");
      },
      onError: (error) => {
        setLoadingShift(null);
        setShowDeleteShiftModal(false);
        setShiftToDelete(null);
        console.log(error);
      }
    }
    triggerDeleteShift(payload);
  }

  const closeShiftDeleteModal = () => {
    setShowDeleteShiftModal(false);
    setShiftToDelete(null);
  }

  const closeRoleDeleteModal = () => {
    setShowDeleteRoleModal(false);
    setRoleShiftToDelete({ roleUUID: "", shiftUUID: "" });
  }

  const openEditShiftPopup = (id) => {
    const payload = {
      id,
      onSuccess: (response) => {
        setCurrentShiftId(id);
        setIsEditShift(true);
        setShowShiftPopup(true);
      },
      onError: (error) => {
        console.log('in here', error);
      }
    };
    triggerGetEventShifts(payload);    
  }

  const closePopup = () => {
    setCurrentShiftId(null);
    setIsEditShift(false);
    setShowShiftPopup(false);
    getUpdatedShiftList();
  }

  const closeRolePopup = () => {
    setShowAddRole(false);
    setLoadingShift(null);
    setShiftUUIDForRole(null);
    setIsRoleEdit(false);
    setRoleUUIDForEdit(null);
    setIsViewRole(false);
  }

  const openCreateShiftPopup = () => {
    const payload = {
      onSuccess: () => {
        setCurrentShiftId(null);
        setIsEditShift(false);
        setShowShiftPopup(true);
      }
    };
    triggerClearShiftDetails(payload);
  }

  const onEditRole = ({ roleUUID, shiftUUID }) => {
    triggerUpdateRoleToTemplateForEdit({ roleUUID, shiftUUID });
    setRoleUUIDForEdit(roleUUID);
    setIsRoleEdit(true)
    setShowAddRole(true);
  }

  const onViewRole = ({ roleUUID, shiftUUID }) => {
    triggerUpdateRoleToTemplateForEdit({ roleUUID, shiftUUID });
    setRoleUUIDForEdit(roleUUID);
    setIsViewRole(true)
    setShowAddRole(true);
  }

  const addPerson = (personUUID) => {
    if(selectedRoleUUID && personUUID && eventUUID) {
      const payload = {
        actualPayload: {
          event_shift2role_uuid: selectedRoleUUID,
          person_uuid: personUUID
        },
        eventUUID,
        onSuccess: (response) => {
          setSelectedTalentForRole([...selectedTalentForRole, response?.uuid]);
          toastSuccess("Person added successfully");
        },
        onError: (error) => {
          toastError("Error in person add");
          console.log(error);
        }
      }
      triggerAddPersonToRole(payload);
    }
  }

  const updatePerson = (personUUID) => {
    if(personUUID && eventUUID) {
      const payload = {
        actualPayload: {
          uuid: personUUID,
          approved_at:  moment().utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
        },
        eventUUID,
        onSuccess: () => {
          toastSuccess("Person confirmed successfully");
        },
        onError: (error) => {
          toastError("Error in person confirmation");
          console.log(error);
        }
      }
      triggerUpdatePersonToRole(payload);
    }
  }

  const removePerson = (rolePersonUUID) => {
    const payload = {
      eventShiftRolePersonUUID: rolePersonUUID,
      eventUUID,
      onSuccess: () => {
        toastSuccess("Person removed successfully");
      },
      onError: (error) => {
        toastError("Error in person delete");
        console.log(error);
      }
    }
    triggerDeletePersonFromRole(payload);
  }

  const closeTalentPopup = () => {
    setShowTalentAddPopup(false);
    setSelectedRoleUUID(null);
  }

  const handleClickPersonAddBtn = (record) => {
    const existingPersonUUID = record?.people?.map(r => r.uuid);
    setSelectedTalentForRole(existingPersonUUID);
    setSelectedRoleUUID(record.uuid);
    setShowTalentAddPopup(true);
  }

  const handleGenerateTiers = (shift) => {
    setSelectedSection(3)
  }

  const getRoleStatus = (role) => {
    const approved = role?.stats?.approved || 0;
    const needed = role?.talent_needed || 0;

    if (approved === 0) return "empty";
    if (approved < needed) return "understaffed";
    if (approved > needed) return "overstaffed";
    return "fullystaffed";
  };

  return (
    <>
      {shiftList?.length > 0 &&
        shiftList.map((shift, index) => {
          shift?.roles?.map((role, index) => role["key"] = index + 1);
          let stats="";
          let statsColor="";

          const roleStatuses = shift.roles.map(getRoleStatus);

          const isEmpty = !roleStatuses.length;

          const hasUnderstaffed = roleStatuses.some(
            s => s === "understaffed" || s === "empty"
          );

          const allFullyStaffed = roleStatuses.every(
            s => s === "fullystaffed"
          );

          const hasOverstaffed = roleStatuses.some(
            s => s === "overstaffed"
          );

          const restAreFullyOrOver = roleStatuses.every(
            s => s === "fullystaffed" || s === "overstaffed"
          );

          if (isEmpty) {
            stats = "Empty Shift";
            statsColor = roleStatsColor.red;
          } else if (hasUnderstaffed) {
            stats = "Understaffed";
            statsColor = roleStatsColor.yellow;
          } else if (allFullyStaffed) {
            stats = "Fully Staffed";
            statsColor = roleStatsColor.green;
          } else if (hasOverstaffed && restAreFullyOrOver) {
            stats = "Overstaffed";
            statsColor = roleStatsColor.pink;
          }

          return (
            <div
              className={`event-shifts border rounded-md border-[#ddd] p-2 ${
                index !== 0 && "mt-6"
              }`}
              key={shift?.UUID}
            >
              {/* Shift header */}
              <ShiftHeader
                shift={shift}
                stats={stats}
                statsColor={statsColor}
                getShiftDate={getShiftDate}
                openEditShiftPopup={openEditShiftPopup}
                setShiftToDelete={setShiftToDelete}
                setShowDeleteShiftModal={setShowDeleteShiftModal}
              />
              <div className="px-2 mt-2" ref={tableRef}>
                <Table
                  rowkey={(record) => record?.UUID}
                  expandable={{
                    expandedRowRender: (record) => (
                      <RoleExpandableRow
                        record={record}
                        handleClickPersonAddBtn={handleClickPersonAddBtn}
                        updatePerson={updatePerson}
                        removePerson={removePerson}
                        baseUrl={baseUrl}
                      />
                    ),
                    expandIcon: ({ expanded, onExpand, record }) =>
                      expanded ? (
                        <DownOutlined onClick={(e) => onExpand(record, e)} />
                      ) : (
                        <RightOutlined onClick={(e) => onExpand(record, e)} />
                      ),
                  }}
                  loading={loadingShift === shift?.UUID}
                  dataSource={shift?.roles}
                  showHeader={true}
                  className={`w-full font-inter ${
                    !shift?.roles?.length && "empty-table"
                  }`}
                  locale={{
                    emptyText: <div className="empty-shift"></div>,
                  }}
                  onRow={(record, rowIndex) => {
                    return {
                      onClick: () => {
                        toggleMoreOptions();
                      },
                    };
                  }}
                  pagination={false}
                >
                  {/* Role in shift table */}
                  <Column
                    title="Role"
                    className="w-[12%]"
                    render={(val) => <EventRoleTag role={val?.event_role} />}
                  />

                  {/* Skills in shift table */}
                  <Column title="Skills" className="w-[14%]" render={(val) => <Skills val={val} />} />
                  {/* Minimum rating in shift table */}
                  <Column
                    title="Min Rtg"
                    className="w-[7%] !text-center"
                    render={(val) => <MinRating value={val?.minimum_rating} />}
                  />
                  {/* Composition in shift table */}
                  <Column
                    title="Composition"
                    className="w-[14%]"
                    render={(val) => <Composition val={val} />}
                  />
                  {/* Sub location in shift table */}
                  <Column
                    title="Sublocation"
                    className="w-[10%]"
                    render={(val) => <SubLocation value={val?.sub_location} />}
                  />
                  {/* Notes in shift table */}
                  <Column
                    title="Notes"
                    className="w-[14%]"
                    render={(val) => <Notes value={val?.desc} />}
                  />
                  {/* Attire in shift table */}
                  <Column
                    title="Attire"
                    className="w-[14%]"
                    render={(val) => <Attire value={val?.attire_reqs} />}
                  />
                  {/* Rate in shift table */}
                  <Column
                    title="Rate"
                    className="w-[4%]"
                    render={(val) => <Rate value={val?.hourly_cost} />}
                  />
                  {/* Staff in shift table */}
                  <Column
                    title="Staff"
                    className="w-[8%] text-center"
                    render={(val) => <Staff val={val} />}
                  />
                  {/* More actions in shift table */}
                  <Column
                    className="w-[3%] text-center"
                    render={(val) => (
                      <RoleActionsMenu
                        val={val}
                        shiftUUID={shift?.UUID}
                        moreOptionRoleUUID={moreOptionRoleUUID}
                        toggleMoreOptions={toggleMoreOptions}
                        onViewRole={onViewRole}
                        duplicateRole={duplicateRole}
                        onEditRole={onEditRole}
                        setRoleShiftToDelete={setRoleShiftToDelete}
                        setShowDeleteRoleModal={setShowDeleteRoleModal}
                      />
                    )}
                  />
                </Table>
              </div>
              <AddGenerateRoleActions
                shift={shift}
                setShiftUUIDForRole={setShiftUUIDForRole}
                setShowAddRole={setShowAddRole}
                handleGenerateTiers={handleGenerateTiers}
              />
            </div>
          );
        })}
      {/* Add shift */}
      <div className="mt-8">
        <Button
          className="flex font-inter font-medium text-sm text-fontGray border rounded-[8px] px-[10px] py-[6px]"
          onClick={() => {
            openCreateShiftPopup();
          }}
          icon={<PlusOutlined className="align-baseline mt-three" />}
        >
          Add Shift
        </Button>
      </div>
      {/* Condition based modals popup */}
      {showDeleteRoleModal && (
        <DeleteRole
          onCancel={closeRoleDeleteModal}
          onConfirm={deleteRoleFromShift}
        />
      )}
      {showDeleteShiftModal && (
        <DeleteShift
          onCancel={closeShiftDeleteModal}
          onConfirm={deleteShiftFromEvent}
        />
      )}
      {showAddRole && (
        <AddRole
          closeRolePopup={closeRolePopup}
          setLoadingShift={setLoadingShift}
          shiftUUIDForRole={shiftUUIDForRole}
          roleUUIDForEdit={roleUUIDForEdit}
          showEditIcon={isRoleEdit || isViewRole}
          isViewRole={isViewRole}
          eventUUID={eventUUID}
        />
      )}
      {showShiftPopup && (
        <ShiftPopup
          setShowShiftPopup={setShowShiftPopup}
          isEditShift={isEditShift}
          setIsEditShift={setIsEditShift}
          shiftId={currentShiftId}
          isAutoGeneratedAndUntouched={false}
          closePopup={closePopup}
        />
      )}
      {showTalentAddPopup && (
        <AddTalent closeTalentPopup={closeTalentPopup} addPerson={addPerson} selectedRoleUUID={selectedRoleUUID} selectedTalentForRole={selectedTalentForRole} />
      )}
    </>
  );
};

const mapDispatchToProps = {
  triggerCloneRole: cloneRole,
  triggerDeleteRole: deleteRole,
  triggerDeleteShift: deleteShift,
  triggerGetEventShifts: getEventShiftDetails,
  triggerClearShiftDetails: clearShiftDetails,
  triggerUpdateRoleToTemplateForEdit: updateRoleToTemplateForEdit,
  triggerAddPersonToRole: addPersonToRole,
  triggerDeletePersonFromRole: deletePersonFromRole,
  triggerUpdatePersonToRole: updatePersonToRole
};

export default connect(null, mapDispatchToProps)(ShiftList);
